import { Autocomplete, Chip, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAssets } from "../../assets/contexts/AssetsContext";

const AssetComparisonPicker = ({ selectedIds = [], onChange }) => {
  const { t } = useTranslation("analytics");
  const { assets } = useAssets();

  const options = (assets || []).map((a) => ({
    id: a.id,
    label: a.title,
  }));

  const selected = options.filter((o) => selectedIds.includes(o.id));

  return (
    <Autocomplete
      multiple
      size="small"
      limitTags={2}
      options={options}
      getOptionLabel={(o) => o.label}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      value={selected}
      onChange={(_, newValue) => {
        if (newValue.length <= 5) {
          onChange(newValue.map((v) => v.id));
        }
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            size="small"
            label={option.label}
            {...getTagProps({ index })}
            key={option.id}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={
            selectedIds.length === 0 ? t("comparison.placeholder") : ""
          }
          sx={{ minWidth: 250 }}
        />
      )}
      noOptionsText={t("comparison.noOptions")}
      sx={{ minWidth: 250 }}
    />
  );
};

export default AssetComparisonPicker;
